
<app-nav></app-nav>
<Section class="submission">
  <!-- view card starts -->
  <div class="modal-container-vm ">
    <div class="modal-overlay-vm"></div>
    <div class="modal-card-vm">
      <p class="sub-title mt-4"></p>


      <div class="home-tabs">
        <ul>
          <li (click)="policyPart=true;editPolicyPart=false;renewPolicyPart=false;claimPart=false;"
            [ngClass]="{ 'active': policyPart}">Policy Details</li>
          <li (click)="policyPart=false;editPolicyPart=true;renewPolicyPart=false;claimPart=false;"
            [ngClass]="{'active': editPolicyPart}">Edit Policy</li>
          <li (click)="policyPart=false;editPolicyPart=false;renewPolicyPart=true;claimPart=false;"
            [ngClass]="{ 'active': renewPolicyPart}">Renew Policy</li>
          <li (click)="policyPart=false;editPolicyPart=false;renewPolicyPart=false;claimPart=true"
          [ngClass]="{'active': claimPart}" routerLink="/register">Claims</li>
        </ul>
      </div>

      <div class="main-box-bg">
      <div class="container pt-4">
 
        <div *ngIf="isCorporateEB" >
          <div class="row justify-content-between align-items-center">
            <span class="policyName">{{this.policyName}}</span>
            <img class="insurerLogo" src="{{this.insurerLogo}}" alt="">
          </div>
        </div>
        <div *ngIf="!isCorporateEB" >
            <div class="row justify-content-between align-items-center">
              <span class="policyName">{{this.policyName}}</span>
              <img class="insurerLogo"  src="{{this.insurerLogo}}" alt="">
            </div>
        </div>        
        <!-- <img class="insurerLogo" src="assets/images/RSAIC.png" alt=""> -->

      </div>
      <section *ngIf="policyPart">
        <div class="pt-2 content-box container mt-2">
          <div class="row">
            <div [ngClass]="{'col-md-7' : isCorporateEB, 'col-md-12' : !isCorporateEB}">
              <div class="row card-class mb-4">
                <div class="col-md-12">
                  <h5 class="policy-head">Policy Details</h5>
                  <hr/>
                </div>
                <div class="col-md-3 col-6">
                  <div class="cardFields">Policy No.</div>
                  <div class="cardFieldsVal">{{this.policyNumber}}</div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="cardFields">Policy Type</div>
                  <div class="cardFieldsVal">{{this.policyType}}</div>
                </div>

                <div class="col-md-3 col-6">
                  <div class="cardFields">Premium Paid</div>
                  <div class="cardFieldsVal">{{this.premiumPaid}}</div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="cardFields">Sum Insured</div>
                  <div class="cardFieldsVal">{{this.sumInsured}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Start Date</div>
                  <div class="cardFieldsVal">{{this.startDate | date}}</div>
                </div>
                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">End Date</div>
                  <div class="cardFieldsVal">{{this.endDate | date}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Policy Holder</div>
                  <div class="cardFieldsVal">{{this.policyHolder}}</div>
                </div>
                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Insurer</div>
                  <div class="cardFieldsVal">{{this.insurer}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">TPA</div>
                  <div class="cardFieldsVal" *ngIf="this.tpa">{{this.tpa}}</div>
                  <div class="cardFieldsVal" *ngIf="!this.tpa">-</div>
                </div>
        

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Email</div>
                  <div class="cardFieldsVal">{{this.email}}</div>
                </div>
                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Mobile</div>
                  <div class="cardFieldsVal">{{this.mobile}}</div>
                </div>
                <div class="col-md-3 col-12 mt-4">
                  <div class="cardFields">Policy Copy File</div>
                  <a *ngIf="this.policyCopyFileName" href="{{this.policyCopyUrl}}" class="cardFieldsVal">{{this.policyCopyFileName}}</a>
                  <div *ngIf="!this.policyCopyFileName" class="cardFieldsVal">NA</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Payment Type</div>
                  <div class="cardFieldsVal">{{this.paymentType}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Policy Cover Type</div>
                  <div class="cardFieldsVal">{{this.policyCoverType}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Family Definition</div>
                  <div class="cardFieldsVal">{{this.familyDefinition}}</div>
                </div>

                <div class="col-md-3 col-6 mt-4">
                  <div class="cardFields">Download Policy</div>

                  <div class="cardFieldsVal" *ngIf="selfPolicyAttachment; else noFile">
                    <a [href]="selfPolicyAttachment" target="_blank" class="download-btn">
                      <i class="pi pi-download"></i> Download
                    </a>
                  </div>

                  <ng-template #noFile>
                    <div class="no-file">No file available</div>
                  </ng-template>
              </div>
                
              </div>
              <ng-container *ngIf="isCorporateEB">
                <div class="row card-class mb-4">
                  <div class="col-md-12">
                    <h5 class="policy-head">eClaims</h5><hr/>
                  </div>
                  <!-- <div class="col-md-2 col-6">
                    <div class="cardFields">Cashless</div>
                    <div class="cardFieldsVal">{{claimsInfo.cashlessClaimsCount ? claimsInfo.cashlessClaimsCount : '-'}}</div>
                  </div> -->
                  <div class="col-md-3 col-6">
                    <div class="cardFields">Reimbursements</div>
                    <div class="cardFieldsVal"><a class="linkExcel" (click)="exportEclaims()">{{claimsInfo.reimbursementClaimsCount ? claimsInfo.reimbursementClaimsCount : '-'}}</a></div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="cardFields">Paid</div>
                    <div class="cardFieldsVal">{{claimsInfo.paidClaimsCount ? claimsInfo.paidClaimsCount : '-'}}</div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="cardFields">Outstanding</div>
                    <div class="cardFieldsVal">{{claimsInfo.outstandingClaimsCount ? claimsInfo.outstandingClaimsCount : '-'}}</div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="cardFields">Repudiated</div>
                    <div class="cardFieldsVal">{{claimsInfo.repudatedClaimsCount ? claimsInfo.repudatedClaimsCount: '-'}}</div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="cardFields">Closed</div>
                    <div class="cardFieldsVal">{{claimsInfo.closedClaimsCount ? claimsInfo.closedClaimsCount : '-'}}</div>
                  </div>
                </div>
                <div class="row card-class mb-4" *ngIf="policyName=='Group Health Insurance'||policyName=='Group Personal Accident'||policyName=='Group Term Life'||policyName=='Group Top Up Health Insurance'|| policyName=='Group OPD Plan'">
                  <div class="col-md-12">
                    <h5 class="policy-head">Endorsement</h5><hr/>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3 col-6">
                        <div class="cardFields">Available CD Balance</div>
                        <div class="cardFieldsVal"><a class="linkExcel" (click)="exportCDLedger()">{{holdData.balance}}</a></div>
                      </div>
                      <div class="col-md-3 col-6">
                        <div class="cardFields">Hold Balance</div>
                        <div class="cardFieldsVal">{{holdData.totalHoldCdBalance}}</div>
                      </div>
                      <div class="col-md-3 col-6">
                        <div class="cardFields">Last CD-Entry Date</div>
                        <div class="cardFieldsVal">{{holdData.entryDate | date}}</div>
                      </div>
                      <div class="col-md-3 col-6">
                        <div class="cardFields">Last CD-Entry Type</div>
                        <div class="cardFieldsVal">{{holdData.entryType}}</div>
                      </div>
                    </div>
                    <hr/>
                  </div>
                  <div class="col-md-12 d-none d-md-block">
                    <div>
                      <h5 class="cardFields">Active Employee Data</h5>
                    </div>
                    <div class="row">
                      <div (click)="routeToEndoView('view')" class="col-md-2 col-2 d-flex icon-class">
                        <i class="fa fa-eye pt-1 pr-2" aria-hidden="true"></i>
                        <p>View</p>
                      </div>
                      <ng-container *ngIf=isManagerialLogin>
                      <div (click)="routeToEndoView('add')" class="col-md-2 col-2 d-flex icon-class">
                        <i class="fa fa-plus pt-1 pr-2" aria-hidden="true"></i>
                        <p>Add</p>
                      </div>
                      <div (click)="routeToEndoView('edit')" class="col-md-2 col-2 d-flex icon-class">
                        <i class="fa fa-pen pt-1 pr-2"></i>
                        <p>Edit</p>
                      </div>
                      <div (click)="routeToEndoView('delete')" class="col-md-2 col-2 d-flex icon-class">
                        <i class="fa fa-solid fa-trash pt-1 pr-2"></i>
                        <p>Delete</p>
                      </div>
                      <div (click)="routeToEndoView('upload')" class="col-md-2 col-2 d-flex icon-class">
                        <i class="fa fa-upload pt-1 pr-2" aria-hidden="true"></i>
                        <p>Upload</p>
                      </div>
                    </ng-container>
                    </div>
                  </div>
                </div>
                <div class="row mb-3 card-class mb-4">
                  <div class="col-md-12">
                    <h5 class="policy-head">Engagement Activity</h5><hr/>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-4 col-6">
                        <div class="cardFields">APP Downloads</div>
                        <div class="cardFieldsVal"><a class="linkExcel" (click)="exportAppDownload()">{{appCount ? appCount: '-'}}</a></div>
                      </div>
                      <div class="col-md-4 col-6">
                        <div class="cardFields">Help Desk</div>
                        <div class="cardFieldsVal">-</div>
                      </div>
                      <div class="col-md-4 col-12 mt-2">
                        <div class="cardFields"><button class="btn btn-secondary" (click)="showChatConversation()">Support Tickets/Emails</button></div>
                        <div class="cardFieldsVal"></div>
                      </div>
                    </div>
                    <hr/>
                    <div class="row">
                      <div (click)="routeToEngagementActivity('Onboarding')" class="col-6 d-flex icon-class">
                        <i class="fa fa-eye pt-1 pr-2" aria-hidden="true"></i>
                        <p>Onboarding Chart</p>
                      </div>
                      <div (click)="routeToEngagementActivity('Ongoing')" class="col-6 d-flex icon-class">
                        <i class="fa fa-eye pt-1 pr-2" aria-hidden="true"></i>
                        <p>Ongoing Engagement</p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
          </div>  
          <div class="modal fade bd-example-modal-xl" id="conversationModal" >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content" >
                <div class="modal-header text-center" style="background-color: #eceffe">
                 <span><img  style="margin-right: 8px" src="https://static-files-website.s3.ap-south-1.amazonaws.com/logo.png">Support Tickets/Emails</span>
                </div>
                <!-- Modal body -->
                <div class="modal-body" style="padding: 0 !important;">
                    <div class="chat-box" *ngIf="converstaionarr.length>0" style="background-color: white; max-height: 400px; overflow-y: auto; overflow-x: hidden;" >
                      <div  *ngFor="let emailClient of converstaionarr; let i = index">
                      <div class="row" style='background-color: #FCD732; position: sticky; top:0; padding-left: 10px;'>
                        <div class="col-md-2 col-2 "><label class='mail-header'>Sending Date</label><p class="header-content">{{emailClient.sentDate | date}}</p></div>
                        <div class='col-md-10 col-10 '><label class='mail-header'>Subject</label><p class="header-content">{{emailClient.subject}}</p></div>
                      </div>
                      <div *ngFor="let message of emailClient.mailContent; let y = index">
                        <div><p class="" style="padding-left: 10px !important; margin-top: 5px;" innerHTML={{message}}></p></div> 
                        <hr style='height:2px !important;background-color: #f1f5f9'>
                      </div>
                      </div>
                    
                     
                    </div>
                    <div *ngIf="converstaionarr.length===0">
                      <label>No Conversation Found</label>
                    </div>

             
                </div>
        
                <!-- Modal footer -->
                <div class="modal-footer text-center">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeChatConversation()">Close</button>
                </div>
        
              </div>
            </div>
          </div>
          <div class="col-md-5" *ngIf="isCorporateEB">
            <div class="card-class pb-4">
              <h5 class="policy-head text-center">eClaims Breakup</h5>
              <div class="mt-5"
                *ngIf="!ischartData">
                <canvas baseChart
          [data]="doughnutChartData"
          [type]="doughnutChartType"
          [options]="doughnutChartOptions">
            </canvas>
              </div>
           <div class="mt-5 text-center" *ngIf = "ischartData">
           No Data Available
         </div>
           <div class="mis-report" (click)="misPdfDownload()">
             <img src="https://s3.ap-south-1.amazonaws.com/static-files-website/common-images/pdf-icon.png" />
            View MIS Report
           </div>
          </div>
        </div>
      </div>
        

        </div>
      </section>

      <section *ngIf="editPolicyPart">
        <div *ngIf="!editMailSentSuccessfull">
          <div class="container">
            <div class="col">
              <form #formClaimIntimate="ngForm">
                <div class="row sum-container">
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Number</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyNumber" id="policyNumber" [(ngModel)]="policyNumber"
                          #policyNumberList="ngModel" value="{{this.policyNumber}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Type</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyType" id="policyType" [(ngModel)]="policyType"
                          #policyTypes="ngModel" value="{{this.policyType}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Holder</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyHolder" id="policyHolder" [(ngModel)]="policyHolder"
                          #policyHolders="ngModel" value="{{this.policyHolder}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Start Date</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" type="text" name="startDate" id="startDate" [ngModel]="startDate | date: 'dd/MM/yyyy'"
                          #policyStartDate="ngModel" (ngModelChange)="startDate=$event" value="{{this.startDate}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">End Date</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="endDate" id="endDate" [ngModel]="endDate | date: 'dd/MM/yyyy'"
                          #policyEndDate="ngModel" (ngModelChange)="endDate=$event" value="{{this.endDate}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Premium</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="premium" id="premium" [(ngModel)]="premiumPaid"
                          #premium="ngModel" value="{{this.premiumPaid}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Sum Insured</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="sumInsured" id="sumInsured" [(ngModel)]="sumInsured"
                          #sInsured="ngModel" value="{{this.sumInsured}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Insurer</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="insurer" id="insurer" [(ngModel)]="insurer"
                          #selectInsurer="ngModel" value="{{this.insurer}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">TPA</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="tpa" id="tpa" [(ngModel)]="tpa" #selectedTpa="ngModel"
                          value="{{this.tpa}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Email</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="email" id="email" [(ngModel)]="email" #selectedEmail="ngModel"
                          value="{{this.email}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Mobile</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="tpa" id="mobile" [(ngModel)]="mobile"
                          #selectedMobile="ngModel" value="{{this.mobile}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <p class="title mt-4">Comment</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control comment-box" name="comment" id="comment"
                          [(ngModel)]="selectedComment" #comment="ngModel"
                          placeholder="Tell us what do you want to change…" />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                        <span class="call-back-text">*Our Executive will reach out to you in 24 hours</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="text-center top-gap-lg mb-4">
                      <button class="btn btn-bordered-blue" [disabled]="!formClaimIntimate.form.valid"
                        (click)="submitEditOrRenewRequest('Edit')">Send</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="intimate-successfull" *ngIf="editMailSentSuccessfull ">
          <div class="container">
        
            <!-- content -->
            <div class="col text-center">
              <h2 class="done-heading">Mail Sent</h2>
              <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
            </div>
        
            <center class="sub-title mt-2">
              <p>THANK YOU</p>
            </center>
        
            <div class="col note text-center">
              <p>We have recieved your request. <br> We will call you back in 24 hours.</p>
            </div>
        
            <!-- footer -->
            <div class="col footer-strip text-center">
              <p>For any queries, please reach us at:</p>
              <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg" class="img-responsive" width="40%"
                alt="Securenow">
              <p class="call mt-3">
                <span>+91 9696683999</span>
                <span class="bar"></span>
                <span>support@securenow.in</span>
              </p>
            </div>
        
          </div>
        </div>
      </section>

      <section *ngIf="renewPolicyPart">
        <div *ngIf="!renewMailSentSuccessfull">
          <div class="container">
            <div class="col">
              <form #formClaimIntimate="ngForm">
                <div class="row sum-container">
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Number</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyNumber" id="policyNumber" [(ngModel)]="policyNumber"
                          #policyNumberList="ngModel" value="{{this.policyNumber}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Type</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyType" id="policyType" [(ngModel)]="policyType"
                          #policyTypes="ngModel" value="{{this.policyType}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4 mendate">Policy Holder</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="policyHolder" id="policyHolder" [(ngModel)]="policyHolder"
                          #policyHolders="ngModel" value="{{this.policyHolder}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Start Date</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="startDate" id="startDate" [ngModel]="startDate | date: 'dd/MM/yyyy'"
                          #policyStartDate="ngModel" (ngModelChange)="startDate=$event"value="{{this.startDate}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">End Date</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="endDate" id="endDate" [ngModel]="endDate | date: 'dd/MM/yyyy'"
                          #policyEndDate="ngModel" (ngModelChange)="endDate=$event" value="{{this.endDate}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Premium</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="premium" id="premium" [(ngModel)]="premiumPaid"
                          #premium="ngModel" value="{{this.premiumPaid}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Sum Insured</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="sumInsured" id="sumInsured" [(ngModel)]="sumInsured"
                          #sInsured="ngModel" value="{{this.sumInsured}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Insurer</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="insurer" id="insurer" [(ngModel)]="insurer"
                          #selectInsurer="ngModel" value="{{this.insurer}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">TPA</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="tpa" id="tpa" [(ngModel)]="tpa" #selectedTpa="ngModel"
                          value="{{this.tpa}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Email</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="email" id="email" [(ngModel)]="email" #selectedEmail="ngModel"
                          value="{{this.email}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <p class="title mt-4">Mobile</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control" name="tpa" id="mobile" [(ngModel)]="mobile"
                          #selectedMobile="ngModel" value="{{this.mobile}}" disabled />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <p class="title mt-4">Comment</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input class="form-control comment-box" name="comment" id="comment"
                          [(ngModel)]="selectedComment" #comment="ngModel"
                          placeholder="Tell us what do you want to change…" />
                        <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                  <div *ngIf="policyNumberList.errors.required">
                                      Policy Number is required.
                                  </div>
                              </div> -->
                        <span class="call-back-text">*Our Executive will reach out to you in 24 hours</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="text-center top-gap-lg mb-4">
                      <button class="btn btn-bordered-blue" [disabled]="!formClaimIntimate.form.valid"
                        (click)="submitEditOrRenewRequest('Renew', selectedComment)">Request Renew</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="intimate-successfull" *ngIf="renewMailSentSuccessfull ">
          <div class="container">
            <div class="col text-center">
              <h2 class="done-heading">Mail Sent</h2>
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
            </div>
            <center class="sub-title mt-2">
              <p>THANK YOU</p>
            </center>
            <div class="col note text-center">
              <p>We have recieved your request. <br> We will call you back in 24 hours.
              </p>
            </div>
            <div class="col footer-strip text-center">
              <p>For any queries, please reach us at:</p>
              <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                class="img-responsive" width="40%" alt="Securenow">
              <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- <section *ngIf="claimPart">
        <div class="container">
          <div class="col">
            <form #formClaimIntimate="ngForm">
              <div class="col sum-container">
                <p class="title mt-4 mendate">Insurer</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="insurer" id="insurer" [(ngModel)]="selectedInsurerName"
                      #insurerList="ngModel" (change)="getInsurerData()" required>
                      <option disabled selected value="">Select Insurer</option>
                      <option value="{{insurerName}}" *ngFor="let insurerName of insurer">{{insurerName | uppercase}}
                      </option>
                    </select>
                    <div *ngIf="insurerList.invalid && insurerList.touched " class="error-message">
                      <div *ngIf="insurerList.errors.required">
                        Insurer is required.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Policy Number</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="policyNumber" id="policyNumber"
                      [(ngModel)]="selectedPolicyNumber" #policyNumberList="ngModel" (change)="getPolicyNumberData()"
                      required disabled>
                      <option disabled selected value="">Select Policy Number</option>
                      <option value="{{policy}}" name="policy" *ngFor="let policy of policyNumber">
                        {{policy}}</option>
                    </select>
                    <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                      <div *ngIf="policyNumberList.errors.required">
                        Policy Number is required.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Patient Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <div class="sum-insured-input">
                      <div class="form-group" *ngIf="!individualInsuranceClaimant">
                        <select class="form-control" name="claimant" id="claimant" [(ngModel)]="selectedClaimantName"
                          (change)="getCardNumberData()" required disabled>
                          <option disabled selected value="">Select Patient Name</option>
                          <option [ngValue]="name" *ngFor="let name of claimantName">{{name | uppercase}}</option>
                        </select>
                      </div>
                      <div class="form-group" *ngIf="individualInsuranceClaimant">
                        <input class="form-control" name="claimant" id="claimant" [(ngModel)]="claimant"
                          value="{{claimantName}}" disabled required>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Relation with Claimant</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="relation" id="relation" [(ngModel)]="selectedRelation"
                      #relation="ngModel" required>
                      <option disabled selected value="">Select Relation</option>
                      <option [ngValue]="relationName" *ngFor="let relationName of relationLists">
                        {{relationName | uppercase}}</option>
                    </select>
                    <div *ngIf="relation.invalid && relation.touched " class="error-message">
                      <div *ngIf="relation.errors.required">
                        Relation is required.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Treatment for</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" class="form-control city-input" [typeahead]="diseaseList" [isAnimated]="true"
                      #ailment="ngModel" name="ailment" [(ngModel)]="intimate.ailment" maxlength="50" required />
                    <div class="">
                      <div *ngIf="ailment.invalid && ailment.touched " class="error-message">
                        <div *ngIf="ailment.errors.required">
                          Field is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">E-mail</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="email" name="email" id="email" class="form-control" [(ngModel)]="intimate.email"
                      [email]="true" #email="ngModel" maxlength="200" value="{{intimate.email}}"
                      pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" disabled required>
                    <div *ngIf="email.invalid && email.touched " class="error-message">
                      <div *ngIf="email.errors.required">
                        Email Address is required.
                      </div>
                      <div *ngIf="email.errors.pattern">
                        Please enter the valid e-mail id
                      </div>
                    </div>
                  </div>
                </div>

                <p class="title mt-4 mendate">Mobile no.</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" class="form-control" name="mobile" [(ngModel)]="mobileNumber" #mobile="ngModel"
                      (keydown.space)="$event.preventDefault();" minlength="10" maxlength="10"
                      pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" disabled required />
                    <div *ngIf="mobile.invalid && mobile.touched" class="error-message">
                      <div *ngIf="mobile.errors.required">
                        Mobile number is required.
                      </div>
                      <div *ngIf="mobile.errors.maxlength">
                        Mobile number should not be greater than 10 digits.
                      </div>
                      <div *ngIf="mobile.errors.minlength || !mobile.errors.pattern && !mobile.errors.required">
                        Mobile number must be at least 10 digits long.
                      </div>
                      <div *ngIf="mobile.errors.pattern && !mobile.errors.minlength && !mobile.errors.required">
                        Invalid mobile number.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="title mt-4 mendate">Card no.</p>
                    <div class="sum-insured-input">
                      <div class="form-group" *ngIf="!individualInsuranceClaimant">
                        <input type="text" name="cardNumber" class="form-control" value="{{cardNumber}}"
                          [(ngModel)]="cardNumber" disabled required>
                      </div>
                      <div class="form-group" *ngIf="individualInsuranceClaimant">
                        <input type="number" name="cardNumber" class="form-control" [(ngModel)]="cardNumber" value=""
                          required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="title mt-4">Admission Date</p>
                    <div class="sum-insured-input reg-date-input proposal-date-input">
                      <div class="input-group">
                        <div class="input-group addon">
                          <img
                            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                          <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date" name="regDate"
                            [(ngModel)]="regDate" keepInvalid dateFormat="dd/mm/yy" [monthNavigator]="true"
                            [yearNavigator]="true" yearRange="1900:2100"></p-calendar>
                          <span class="input-group-addon" id="basic-addon-dueDate"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <p class="title mt-4 mendate">Estimated Claim Amount</p>
                    <div class="sum-insured-input">
                      <div class="form-group">
                        <input type="text" name="estimatedAmount" class="form-control"
                          [(ngModel)]="intimate.estimatedAmount" #estimatedAmount="ngModel" maxlength="9"
                          pattern="^[0-9]*$" inputmode="numeric" required>
                        <div *ngIf="estimatedAmount.invalid && estimatedAmount.touched " class="error-message">
                          <div *ngIf="estimatedAmount.errors.required">
                            Claim Amount is required.
                          </div>
                          <div *ngIf="estimatedAmount.errors.pattern">
                            Please enter valid amount.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Hospital State</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" name="hospitalState" [(ngModel)]="intimate.hospitalState"
                      #hospitalState="ngModel" class="form-control" pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="hospitalState.invalid && hospitalState.touched " class="error-message">
                      <div *ngIf="hospitalState.errors.required">
                        Hospital State is required.
                      </div>
                      <div *ngIf="hospitalState.errors.pattern">
                        Please enter valid Hospital State.
                      </div>
                    </div>
                  </div>
                </div>

                <p class="title mt-4 mendate">Hospital City</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" name="hopitalCity" [(ngModel)]="intimate.hospitalCity" #hospitalCity="ngModel"
                      class="form-control" pattern="[a-zA-Z\s]+" maxlength="50" required>
                    <div *ngIf="hospitalCity.invalid && hospitalCity.touched " class="error-message">
                      <div *ngIf="hospitalCity.errors.required">
                        Hospital City is required.
                      </div>
                      <div *ngIf="hospitalCity.errors.pattern">
                        Please enter valid Hospital City.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4 mendate">Hospital Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" name="hospitalName" [(ngModel)]="intimate.hospitalName" #hospitalName="ngModel"
                      class="form-control" pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="hospitalName.invalid && hospitalName.touched " class="error-message">
                      <div *ngIf="hospitalName.errors.required">
                        Hospital Name is required.
                      </div>
                      <div *ngIf="hospitalName.errors.pattern">
                        Please enter valid Hospital Name.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="title mt-4">Discharge Date</p>
                <div class="sum-insured-input reg-date-input">
                  <div class="input-group">
                    <div class="input-group addon">
                      <img
                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                      <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date" name="dischargeDate"
                        [(ngModel)]="dischargeDate" keepInvalid dateFormat="dd/mm/yy" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="1900:2100"></p-calendar>
                      <span class="input-group-addon" id="basic-addon-dueDate"></span>
                    </div>
                  </div>
                </div>
                <div class="text-center top-gap-lg mb-4">
                  <button class="btn btn-bordered-blue" [disabled]="!formClaimIntimate.form.valid"
                    (click)="submitIntimateDetails()">Register Now</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section> -->
      <!-- expanded -->
      <!-- <div class="spacer"></div>

      <div class="spacer"></div> -->
      </div>
    </div>
  </div>
  <!-- view card ends -->

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
 
</Section>
